import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

export const styles = ({ palette }: Theme) =>
  createStyles({
    asterix: {
      color: palette.error.main,
    },
  });
